import {GetExamRequestsModel} from 'domain/usecases/private/exam-results/get-exam-requests';
import {useGetPaginatedItemsReactQuery} from 'presentation/pages/private/hooks/useGetPaginatedItemsReactQuery';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useQueryParams} from 'presentation/pages/private/hooks';
import {QueryParamsEnum} from 'presentation/constants';
import {EntryPointCodeEnum} from 'presentation/pages/private/booking/constants';
import {getExamRequests} from '../../services/getExamRequests';
import {ExamsRequestsFlowEnum} from './types';
import {EXAM_REQUESTS_LIST_SIZE, EXAM_REQUESTS_STATUS} from './constants';

export const useExamRequests = (flow: ExamsRequestsFlowEnum) => {
	const {SEARCH_PARAMS, setSearchParams} = useQueryParams();
	const {month, year, examType: selectedExamType} = SEARCH_PARAMS;
	const hasDateFilterActive = !!month && !!year;
	const selectedDate = hasDateFilterActive
		? new Date(Number(year), Number(month) - 1, 1)
		: undefined;
	const examRequestType = selectedExamType || undefined;

	const hasFilterActive = hasDateFilterActive || !!examRequestType;

	const requestsStatus = EXAM_REQUESTS_STATUS[flow];

	const {
		items,
		loadingItemsList,
		itemsListIsEmpty,
		itemsListHasError,
		isLoadingMore,
		totalItems,
		loadMore,
		resetState,
		refresh,
	} = useGetPaginatedItemsReactQuery<GetExamRequestsModel['result'][0]>({
		queryKey: [
			QUERY_KEYS.EXAM_RESULTS,
			EXAM_REQUESTS_LIST_SIZE,
			selectedDate,
			examRequestType,
			requestsStatus,
		],
		queryFn: ({page}) =>
			getExamRequests({
				entryPoint: EntryPointCodeEnum.V1,
				statusType: requestsStatus,
				referenceDate: selectedDate,
				examType: examRequestType,
				limit: EXAM_REQUESTS_LIST_SIZE,
				page,
			}),
	});

	const handleClearFilters = () => {
		setSearchParams(prev => {
			prev.delete(QueryParamsEnum.EXAM_TYPE);
			prev.delete(QueryParamsEnum.MONTH);
			prev.delete(QueryParamsEnum.YEAR);
			return prev;
		});
	};

	const onSentinelVisible = () => {
		if (items.length > 0) {
			loadMore();
		}
	};

	const hideFilterDrawer = itemsListIsEmpty && !examRequestType;

	return {
		items,
		loadingItemsList,
		isLoadingMore,
		itemsListIsEmpty,
		itemsListHasError,
		totalItems,
		resetState,
		refresh,
		handleClearFilters,
		hasFilterActive,
		hideFilterDrawer,
		onSentinelVisible,
	};
};
